import React from 'react';
import {
	Card,
	Col,
	Row,
	Space,
	Switch,
	Tag,
	Typography,
} from 'antd';

type Props = {
	percent: number;
	euEtsApply: boolean;
	fuelEuApply?: boolean;
	fuelEuEnabled?: boolean;
	euEtsLoading?: boolean;
	fuelEuLoading?: boolean;
	disabled?: boolean;
	onEuEtsChange: (checked: boolean) => void;
	onFuelEuChange?: (checked: boolean) => void;
};

const EuComplianceApply = ({
	percent,
	euEtsApply,
	fuelEuApply,
	euEtsLoading = false,
	fuelEuLoading = false,
	disabled = false,
	onEuEtsChange,
	onFuelEuChange,
	fuelEuEnabled = true,
}: Props) => (
	<Card size="small" styles={{ body: { padding: 12 } }}>
		<Row gutter={[24, 12]} align="middle">
			<Col flex="1">
				<Space size={8} align="center">
					<Typography.Text type="secondary" style={{ whiteSpace: 'nowrap' }}>EU ETS</Typography.Text>
					<Tag style={{ margin: 0, fontWeight: 600 }}>{percent}%</Tag>
					<Switch
						size="small"
						checked={euEtsApply}
						loading={euEtsLoading}
						disabled={disabled}
						onChange={onEuEtsChange}
					/>
				</Space>
			</Col>

			{fuelEuEnabled && (
				<Col flex="1">
					<Space size={8} align="center">
						<Typography.Text 
							type="secondary" 
							style={{ whiteSpace: 'nowrap' }}
						>FuelEU
						</Typography.Text>
						<Tag style={{ margin: 0, fontWeight: 600 }}>{percent}%</Tag>
						<Switch
							size="small"
							checked={fuelEuApply ?? false}
							loading={fuelEuLoading}
							disabled={disabled}
							onChange={onFuelEuChange}
						/>
					</Space>
				</Col>
			)}
		</Row>
	</Card>
);

export default EuComplianceApply;